"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Separator } from "@/components/ui/separator";
export default function OrganizationProfile() {
  const {
    ref: headingRef,
    isVisible: headingVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: paragraphRef,
    isVisible: paragraphVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: cardsRef,
    isVisible: cardsVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const principles = [{
    number: "01",
    title: "INTEGRITAS",
    description: "Menjunjung tinggi nilai kejujuran dan etika jurnalistik dalam setiap pemberitaan nasional yang kami sajikan."
  }, {
    number: "02",
    title: "KOLABORASI",
    description: "Membangun sinergi dengan masyarakat dan mitra strategis untuk menciptakan ekosistem informasi yang transparan."
  }, {
    number: "03",
    title: "PROFESIONAL",
    description: "Mengutamakan akurasi, kecepatan, dan kedalaman analisis dalam menyajikan fakta di lapangan secara objektif."
  }];
  return <section data-section-id="2627" id="organizationprofile" className="bg-white text-black py-40 px-6 md:px-12 lg:px-16 relative overflow-hidden">
      {}
      <Separator className="bg-gray-200 mb-12" />

      {}
      <div className="mb-20 md:mb-24">
        <span className="font-sans text-[11px] tracking-widest text-orange-600 uppercase">
          02 / Filosofi Kami
        </span>
      </div>

      {}
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8 relative">
        {}
        <div className="hidden lg:block absolute pointer-events-none" style={{
        left: "calc(41.666% - 12px)",
        top: "40%"
      }} aria-hidden="true">
          <div className="relative w-6 h-6 opacity-30">
            <div className="absolute top-1/2 left-0 w-full h-px bg-orange-600" />
            <div className="absolute top-0 left-1/2 h-full w-px bg-orange-600" />
          </div>
        </div>

        {}
        <div ref={headingRef} className={`lg:col-span-5 transition-all duration-1000 ease-out ${headingVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-default font-bold leading-[0.9] text-black" style={{
          fontSize: "clamp(3.5rem, 9vw, 6rem)",
          letterSpacing: "-0.03em"
        }}>
            <span className="block">ABADI</span>
            <span className="block">NEWS</span>
            <span className="block text-gray-400">/</span>
            <span className="block">VISI</span>
            <span className="block relative inline-block w-fit">
              UTAMA
              <span className="absolute left-0 right-0 bottom-2 h-3 -z-0" style={{
              backgroundColor: "#ea580c",
              opacity: 0.85,
              mixBlendMode: "normal"
            }} aria-hidden="true" />
            </span>
          </h2>
        </div>

        {}
        <div className="lg:col-span-7 lg:pt-20">
          {}
          <div ref={paragraphRef} className={`transition-all duration-1000 ease-out delay-150 ${paragraphVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <p className="font-sans text-black leading-snug mb-16 md:mb-20" style={{
            fontSize: "clamp(1.25rem, 2.2vw, 1.625rem)"
          }}>
              Kami tidak sekadar melaporkan — kami{" "}
              <em className="italic text-orange-600">mengawal kebenaran</em>. Setiap berita adalah{" "}
              <em className="italic">tanggung jawab</em>. Setiap informasi, sebuah{" "}
              <em className="italic">pengabdian</em>.
            </p>
          </div>

          {}
          <div ref={cardsRef} className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {principles.map((principle, i) => <div key={principle.number} data-index={i} className={`group relative p-6 backdrop-blur-sm border border-gray-200 hover:border-orange-600 shadow-lg hover:shadow-xl transition-all duration-500 ease-out hover:-translate-y-0.5 ${cardsVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`} style={{
            backgroundColor: "white",
            transitionDelay: cardsVisible ? `${i * 120}ms` : "0ms"
          }}>
                {}
                <div className="absolute inset-0 opacity-0 group-hover:opacity-10 transition-opacity duration-500 pointer-events-none" style={{
              boxShadow: "0 0 40px -10px #ea580c"
            }} aria-hidden="true" />

                <div className="relative z-10">
                  {}
                  <span className="font-sans text-[11px] tracking-widest text-orange-600 block mb-8">
                    {principle.number}
                  </span>

                  {}
                  <h3 className="font-default font-bold text-black mb-5" style={{
                fontSize: "1.5rem",
                letterSpacing: "-0.02em"
              }}>
                    {principle.title}
                  </h3>

                  {}
                  <Separator className="bg-gray-200 mb-5" />

                  {}
                  <p className="font-sans text-[15px] leading-relaxed text-gray-600">
                    {principle.description}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}